"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyIndex = exports.toposort = void 0;
const utils_1 = require("./utils");
const visit_1 = require("./visit");
const getAllInvalidations = (invalidations, deps) => {
    const marks = new Map();
    const allInvalidations = new Set();
    const callback = (node) => {
        allInvalidations.add(node);
    };
    for (const node of invalidations) {
        (0, visit_1.visit)(node, marks, deps, callback);
    }
    return allInvalidations;
};
const toposort = (nodes, deps) => {
    const marks = new Map();
    const output = new Array(nodes.size);
    let i = nodes.size;
    const callback = (node) => {
        --i;
        output[i] = node;
    };
    for (const node of nodes) {
        (0, visit_1.visit)(node, marks, deps, callback);
    }
    return output;
};
exports.toposort = toposort;
class DependencyIndex {
    constructor() {
        this.index = new Map();
    }
    addRefToIndex(ref, ownRefPath) {
        const refPath = (0, utils_1.pathToStringPath)(ref.refPath);
        if (!this.index.has(refPath)) {
            this.index.set(refPath, new Set());
        }
        this.index.get(refPath).add(ownRefPath);
    }
    removeRefFromIndex(ref, ownRefPath) {
        if ((0, utils_1.isRef)(ref)) {
            const refPath = (0, utils_1.pathToStringPath)(ref.refPath);
            this.index.get(refPath)?.delete(ownRefPath);
            return true;
        }
    }
    toposort(nodes) {
        return (0, exports.toposort)(nodes, this.index);
    }
    getAllInvalidations(invalidations) {
        return getAllInvalidations(invalidations, this.index);
    }
    clean() {
        for (const [key] of this.index.entries()) {
            const item = this.index.get(key);
            item?.clear();
        }
        this.index.clear();
    }
}
exports.DependencyIndex = DependencyIndex;
//# sourceMappingURL=DependencyIndex.js.map